export default __webpack_public_path__ + "static/media/reward1_detail_5-left.e2fa2c87.svg";